module.exports = __webpack_public_path__ + "img/dahag_no.ee32cad2.png";